import { render, staticRenderFns } from "./TractionDashboard.vue?vue&type=template&id=0702f1fc&scoped=true&"
import script from "./TractionDashboard.vue?vue&type=script&lang=js&"
export * from "./TractionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TractionDashboard.vue?vue&type=style&index=0&id=0702f1fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0702f1fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
